import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './Home';
import Login from './Login';
import Signup from './Signup';
import Signin from './Signin';

import Main from './Main';
import Shopdetails from './Shopdetails';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Productcate from './Productcate';
import Shopcate from './Shopcate';
import UserActivity from './UserActivity';
import Apm from './Apm';
import Instant from './Instant';
import Settings from './Settings';
import Search from './Search';
import Bills from './Bills';
import Billdetails from './Billdetails';
import ComingSoon from './ComingSoon';
import PhoneDth from './PhoneDth';
import CreditCard from './CreditCard';
import SupportForm from './SupportForm';
import AllCate from './AllCate';
import Allinv from './Allinv';
import Orderhistroy from './Orderhistroy';
import Purchasedetails from './Purchasedetails';
import Dailybonus from './Dailybonus';
import Privacy from './Privacy';
import Terms from './Terms';
import Weeklybonus from './Weeklybonus';
import Yearlybonus from './Yearlybonus';
import Monthlybonus from './Monthlybonus';
import Suspendedbonus from './Suspendedbonus';
import ExpiredPoints from './ExpiredPoints';
import Referral from './Referral';
import Monthlypurchess from './Monthlypurchess';
import Yearlypurchese from './Yearlypurchese';
import Taxbills from './Taxbills';
import CustomerReport from './CustomerReport';
import Refund from './Refund';
import CancellationPolicy from './CancellationPolicy/CancellationPolicy';
import ContactUs from './ContactUs/ContactUs';

import About from './About';
import Mpin from './Mpin';
import Loading from './Loading';
import Payment from './Payment';
import BankDetails from './BankDetails';
import ScrollToTop from './ScrollToTop';
import FloatingHelpButton from './FloatingHelpButton';

import RedirectToProperPage from './RedirectToProperPage';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

  
  <AuthProvider>
    <React.StrictMode>
      <Router>
      <ScrollToTop/>
      <FloatingHelpButton />

        <Routes>
        
        <Route path="/" element={<Loading />} />
        <Route path="/Billdetails" element={<Billdetails />} />
        <Route path="/Allinv" element={<Allinv />} />
        <Route path="/AllCate" element={<AllCate />} />
          <Route path="/home" element={<Main />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/Apm" element={<Apm />} />
          <Route path="/Main" element={<Main />} />
          <Route path="/Shopdetails" element={<Shopdetails />} />
          <Route path="/Productcate" element={<Productcate />} />
          <Route path="/Shopcate" element={<Shopcate />} />
          <Route path="/UserActivity" element={<UserActivity />} />
          <Route path="/Instant" element={<Instant />} />
          <Route path="/Settings" element={<Settings />} />
          <Route path="/Search" element={<Search />} />
          <Route path="/Bills" element={<Bills />} />
          <Route path="/ComingSoon" element={<ComingSoon />} />
          <Route path="/PhoneDth" element={<PhoneDth />} />
          <Route path="/CreditCard" element={<CreditCard />} />
          <Route path="/SupportForm" element={<SupportForm />} />
          <Route path="/Orderhistroy" element={<Orderhistroy />} />
          <Route path="/Dailybonus" element={<Dailybonus />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/Weeklybonus" element={<Weeklybonus />} />
          <Route path="/Yearlybonus" element={<Yearlybonus />} />
          <Route path="/Monthlybonus" element={<Monthlybonus />} />
          <Route path="/Suspendedbonus" element={<Suspendedbonus />} />
          <Route path="/ExpiredPoints" element={<ExpiredPoints />} />
          <Route path="/Referral" element={<Referral />} />
          <Route path="/Purchasedetails" element={<Purchasedetails />} />
          <Route path="/Monthlypurchess" element={<Monthlypurchess />} />
          <Route path="/Yearlypurchese" element={<Yearlypurchese />} />
          <Route path="/Taxbills" element={<Taxbills />} />
          <Route path="/CustomerReport" element={<CustomerReport />} />
          <Route path="/Refund" element={<Refund />} />
          <Route path="/CancellationPolicy" element={<CancellationPolicy />} />
<Route path="/ContactUs" element={<ContactUs />} />
<Route path="/About" element={<About />} />
          <Route path="/Mpin" element={<Mpin />} />
          <Route path="/Loading" element={<Loading />} />
          <Route path="/Payment" element={<Payment />} />
          <Route path="/BankDetails" element={<BankDetails />} />

             
                   
          <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        </Routes>
      </Router>
    </React.StrictMode>
  </AuthProvider>
);

reportWebVitals();
